// SIP Tracer — Capture control
export const SIP_TRACE_START_REQUEST = "SIP_TRACE_START_REQUEST";
export const SIP_TRACE_START_SUCCESS = "SIP_TRACE_START_SUCCESS";
export const SIP_TRACE_START_FAIL = "SIP_TRACE_START_FAIL";

export const SIP_TRACE_STOP_REQUEST = "SIP_TRACE_STOP_REQUEST";
export const SIP_TRACE_STOP_SUCCESS = "SIP_TRACE_STOP_SUCCESS";
export const SIP_TRACE_STOP_FAIL = "SIP_TRACE_STOP_FAIL";

// SIP Tracer — Data fetching
export const SIP_TRACE_STATUS_REQUEST = "SIP_TRACE_STATUS_REQUEST";
export const SIP_TRACE_STATUS_SUCCESS = "SIP_TRACE_STATUS_SUCCESS";
export const SIP_TRACE_STATUS_FAIL = "SIP_TRACE_STATUS_FAIL";

export const SIP_TRACE_MESSAGES_REQUEST = "SIP_TRACE_MESSAGES_REQUEST";
export const SIP_TRACE_MESSAGES_SUCCESS = "SIP_TRACE_MESSAGES_SUCCESS";
export const SIP_TRACE_MESSAGES_FAIL = "SIP_TRACE_MESSAGES_FAIL";

export const SIP_TRACE_CALL_MESSAGES_REQUEST = "SIP_TRACE_CALL_MESSAGES_REQUEST";
export const SIP_TRACE_CALL_MESSAGES_SUCCESS = "SIP_TRACE_CALL_MESSAGES_SUCCESS";
export const SIP_TRACE_CALL_MESSAGES_FAIL = "SIP_TRACE_CALL_MESSAGES_FAIL";

export const SIP_TRACE_ERRORS_REQUEST = "SIP_TRACE_ERRORS_REQUEST";
export const SIP_TRACE_ERRORS_SUCCESS = "SIP_TRACE_ERRORS_SUCCESS";
export const SIP_TRACE_ERRORS_FAIL = "SIP_TRACE_ERRORS_FAIL";

export const SIP_TRACE_MESSAGE_DETAIL_REQUEST = "SIP_TRACE_MESSAGE_DETAIL_REQUEST";
export const SIP_TRACE_MESSAGE_DETAIL_SUCCESS = "SIP_TRACE_MESSAGE_DETAIL_SUCCESS";
export const SIP_TRACE_MESSAGE_DETAIL_FAIL = "SIP_TRACE_MESSAGE_DETAIL_FAIL";

// SIP Tracer — Real-time via SocketIO
export const SIP_TRACE_NEW_MESSAGE = "SIP_TRACE_NEW_MESSAGE";
export const SIP_TRACE_BATCH_MESSAGES = "SIP_TRACE_BATCH_MESSAGES";
export const SIP_TRACE_STATS_UPDATE = "SIP_TRACE_STATS_UPDATE";
export const SIP_TRACE_CAPTURE_STOPPED = "SIP_TRACE_CAPTURE_STOPPED";
export const SIP_TRACE_CLEAR = "SIP_TRACE_CLEAR";
